import React from "react";
import { Handle, Position } from "@xyflow/react";
import { NotebookPen } from "lucide-react";
import { ENTITY_COLORS, ENTITY_TEXT, ENTITY_LABELS } from "@/lib/entityColors";

// Custom color-coded knowledge-graph node.
function GraphNode({ data }) {
  const bg = ENTITY_COLORS[data.type] || "#ff7360";
  const fg = ENTITY_TEXT[data.type] || "#fdfdfb";
  const showBadge = data.myLayer && data.noteCount > 0;
  return (
    <div className="relative nodrag" style={{ display: "inline-block" }}>
      <div
        data-testid={`graph-node-${data.id}`}
        title={`${ENTITY_LABELS[data.type] || data.type}: ${data.label}`}
        onClick={(e) => {
          e.stopPropagation();
          data.onSelect?.(data.id);
        }}
        onDoubleClick={(e) => {
          e.stopPropagation();
          data.onFocus?.(data.id);
        }}
        className="rounded-full font-sans font-semibold select-none cursor-pointer transition-transform duration-150 hover:scale-[1.06]"
        style={{
          background: bg,
          color: fg,
          padding: "8px 16px",
          maxWidth: 190,
          fontSize: 13,
          lineHeight: 1.2,
          textAlign: "center",
          border: data.selected ? "3px solid #14140f" : "2px solid rgba(255,255,255,0.5)",
          boxShadow: [
            data.selected
              ? "0 0 0 4px rgba(212,149,42,0.35), 0 8px 20px rgba(28,28,24,0.18)"
              : "0 3px 10px rgba(28,28,24,0.14)",
            showBadge && !data.selected ? "0 0 0 3px rgba(212,149,42,0.85)" : "",
          ].filter(Boolean).join(", "),
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          pointerEvents: "all",
        }}
      >
        <Handle type="target" position={Position.Top} style={{ opacity: 0, width: 1, height: 1 }} />
        {data.label}
        <Handle type="source" position={Position.Bottom} style={{ opacity: 0, width: 1, height: 1 }} />
      </div>
      {showBadge && (
        <span
          data-testid={`node-note-badge-${data.id}`}
          title={`${data.noteCount} of your note${data.noteCount === 1 ? "" : "s"} here`}
          className="absolute -top-2 -right-2 flex items-center gap-0.5 bg-[#ffb020] text-[#14140f] text-[10px] font-bold rounded-full px-1.5 py-0.5 shadow-md pointer-events-none"
          style={{ lineHeight: 1 }}
        >
          <NotebookPen className="w-2.5 h-2.5" />
          {data.noteCount}
        </span>
      )}
    </div>
  );
}

export default GraphNode;
